import Alpine from 'alpinejs';
import { megaMenuInit } from './mega-menu.js';
import { scrollInit } from './scroll.js';
import { bannerInit } from './banner.js';
import { animationInit } from './animation.js';
import { indicatorInit } from './indicator.js';
import { tooltipInit } from './tooltip.js';
import { tabbedNav } from './tabbed';

window.Alpine = Alpine;
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
	megaMenuInit();
	scrollInit();
	bannerInit();
	animationInit();
	indicatorInit();
	tooltipInit();
	tabbedNav();

	// handle the full width banner block for mobile
	// its a bit squarer than 16/9 so we need to resize it until we hit 808px when its 16/9 by default
	const fullwidthBanners = document.querySelectorAll('.full-width-banner');
	if (fullwidthBanners.length > 0) {
		fullwidthBanners.forEach((banner) => {
			const iframe = banner.querySelector('iframe');

			// this only needs to happen for videos which are loaded in an iframe
			if (iframe) {
				// add the resize event listener to the window
				window.addEventListener('resize', () => {
					if (window.innerWidth < 808) {
						// get the container height and set the iframe width to ensure a 16/9 video will fill the container
						const containerHeight = banner.offsetHeight;
						iframe.style.width = `${containerHeight * (16 / 9)}px`;
					} else {
						// the css is setting 16/9 which is the assumed default for all videos being added
						iframe.style.width = '100%';
						iframe.style.height = '100%';
					}
				});

				if (window.innerWidth < 808) {
					// set the initial height
					const containerHeight = banner.offsetHeight;
					iframe.style.width = `${containerHeight * (16 / 9)}px`;
				}
			}
		});
	}

	const buttons = document.querySelectorAll('button[aria-controls]');

	buttons.forEach((button) => {
		button.addEventListener('click', () => {
			const contentId = button.getAttribute('aria-controls');
			const content = document.getElementById(contentId);

			if (content) {
				const expanded =
					button.getAttribute('aria-expanded') === 'true';

				content.style.display = expanded ? 'none' : 'block';
				button.setAttribute('aria-expanded', !expanded);
				button.querySelector('svg').classList.toggle('hidden');
				button.querySelector('svg + svg').classList.toggle('hidden');
			}
		});
	});

	// Initialize the second Swiper instance
	const swiper2 = new Swiper('.swiper-container-2 .swiper', {
		slidesPerView: 'auto',
		spaceBetween: 30,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	const swiper3 = new Swiper('.quoteSwiper .swiper', {
		slidesPerView: 'auto',
		spaceBetween: 30,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	// post-slider
	const postSwiper = new Swiper('.post-slider .swiper', {
		slidesPerView: 'auto',
		spaceBetween: 30,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.post-slider-next',
			prevEl: '.post-slider-prev',
		},
	});

	// insight-slider
	const insightSwiper = new Swiper('.insight-slider .swiper', {
		slidesPerView: 'auto',
		spaceBetween: 30,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		navigation: {
			nextEl: '.insight-slider-next',
			prevEl: '.insight-slider-prev',
		},
	});

	const homepageCarouselSwiper = new Swiper('.homepage-carousel__swiper', {
		slidesPerView: 1.1,
		spaceBetween: 24,
		loop: false,
		navigation: {
			nextEl: '.homepage-carousel__swiper-next',
			prevEl: '.homepage-carousel__swiper-prev',
		},
		pagination: {
			el: '.homepage-carousel__swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			640: { slidesPerView: 2.25, spaceBetween: 24 },
			740: { slidesPerView: 2.5, spaceBetween: 24 },
			1499: { slidesPerView: 3, spaceBetween: 28 },
		},
	});

	// remove the 'open' attribute from the <details> element thats the parent of the .close-details button being clicked
	const closeDetails = document.querySelectorAll('.close-details');
	closeDetails.forEach((button) => {
		button.addEventListener('click', () => {
			const details = button.closest('details');
			details.removeAttribute('open');
		});
	});

	// our people page filters
	const our_people_form_el = document.getElementById('our_people_filter');
	if (our_people_form_el) {
		our_people_form_el.addEventListener('submit', function (event) {
			event.preventDefault();

			// remove any error messages
			const errorElements = document.querySelectorAll(
				'.our-people-filter-feedback'
			);
			errorElements.forEach((element) => {
				element.remove();
			});

			const formData = new FormData(this);

			// Create a new XMLHttpRequest object
			var xhr = new XMLHttpRequest();

			// Configure it: POST request, URL, and asynchronous
			xhr.open('POST', isio.ajax_url, true);

			// Define what happens on successful data submission
			xhr.onload = function () {
				if (xhr.status >= 200 && xhr.status < 400) {
					// Request was successful
					document.getElementById('our_people_content').innerHTML =
						xhr.responseText;
				} else {
					// Error occurred during the request
					// console.error('Error: ' + xhr.status);
				}
				document
					.getElementById('our_people_content_loading')
					.classList.remove('loading');
			};

			// Handle network errors
			xhr.onerror = function () {
				// console.error('Network Error');
				document
					.getElementById('our_people_content_loading')
					.classList.remove('loading');
			};

			// Show loading animation
			document.getElementById('our_people_content').innerHTML = '';
			document
				.getElementById('our_people_content_loading')
				.classList.add('loading');

			// Send the request with the form data
			xhr.send(formData);
		});
	}

	const growBlock = document.querySelector('.grow_block');
	if (growBlock) {
		growBlock.addEventListener('mouseenter', () => {
			growBlock.classList.add('hovered');
		});
	}

	document.querySelectorAll('.homepage-insights').forEach((container) => {
		const tabPanels = container.querySelectorAll(
			'.homepage-insights__tab-panel[data-tab-panel]'
		);
		if (!tabPanels.length) return;

		const tabButtons = container.querySelectorAll(
			'.homepage-insights__taxonomy-buttons .btn-primary[data-tab-target]'
		);

		const swipersByPanelId = {};

		// Init one Swiper per panel
		tabPanels.forEach((panel) => {
			const swiperEl = panel.querySelector('.homepage-insights__swiper');
			if (!swiperEl) return;

			const prevEl = panel.querySelector(
				'.homepage-insights__swiper-prev'
			);
			const nextEl = panel.querySelector(
				'.homepage-insights__swiper-next'
			);
			const panelId = panel.getAttribute('data-tab-panel');
			if (!panelId) return;

			// eslint-disable-next-line no-undef
			swipersByPanelId[panelId] = new Swiper(swiperEl, {
				slidesPerView: 1,
				spaceBetween: 24,
				speed: 600,
				loop: false,
				navigation: { prevEl, nextEl },
				breakpoints: {
					640: { slidesPerView: 2, spaceBetween: 24 },
					740: { slidesPerView: 2.5, spaceBetween: 24 },
					1320: { slidesPerView: 3, spaceBetween: 28 },
				},
			});
		});

		const showTab = (targetId) => {
			if (!targetId) return;

			// Toggle active state on buttons (if any)
			tabButtons.forEach((btn) => {
				const isActive =
					btn.getAttribute('data-tab-target') === targetId;
				btn.classList.toggle('is-active', isActive);
			});

			// Show/hide panels
			tabPanels.forEach((panel) => {
				const id = panel.getAttribute('data-tab-panel');
				panel.style.display = id === targetId ? 'block' : 'none';
			});

			const swiper = swipersByPanelId[targetId];
			if (swiper) {
				requestAnimationFrame(() => {
					swiper.update();
					swiper.slideTo(0);
				});
			}
		};

		// Figure out initial tab ID
		let initialId = null;

		if (tabButtons.length) {
			initialId =
				tabButtons[0].getAttribute('data-tab-target') ||
				tabPanels[0].getAttribute('data-tab-panel');
		} else {
			initialId = tabPanels[0].getAttribute('data-tab-panel');
		}

		showTab(initialId);

		// Wire up clicks if there are buttons
		tabButtons.forEach((button) => {
			button.addEventListener('click', () => {
				const targetId = button.getAttribute('data-tab-target');
				showTab(targetId);
			});
		});
	});

	document.querySelectorAll('.homepage-who-we-help').forEach((wrap) => {
		const swiperEl = wrap.querySelector('.homepage-who-we-help__swiper');
		if (!swiperEl) return;

		const prevEl = wrap.querySelector('.homepage-who-we-help__swiper-prev');
		const nextEl = wrap.querySelector('.homepage-who-we-help__swiper-next');

		new Swiper(swiperEl, {
			slidesPerView: 1.1,
			spaceBetween: 16,
			speed: 600,
			loop: false,
			navigation: { prevEl, nextEl },
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			breakpoints: {
				640: { slidesPerView: 2.25, spaceBetween: 24 },
				740: { slidesPerView: 2.5, spaceBetween: 24 },
				840: { slidesPerView: 3, spaceBetween: 24 },
				1024: { slidesPerView: 3.5, spaceBetween: 28 },
				1320: { slidesPerView: 4, spaceBetween: 28 },
			},
		});
	});

	document.querySelectorAll('.people-block').forEach((wrap) => {
		const swiperEl = wrap.querySelector('.people-block__swiper');
		if (!swiperEl) return;

		const prevEl = wrap.querySelector('.people-block__swiper-prev');
		const nextEl = wrap.querySelector('.people-block__swiper-next');

		new Swiper(swiperEl, {
			slidesPerView: 1.1,
			spaceBetween: 16,
			speed: 600,
			loop: false,
			navigation: { prevEl, nextEl },
			breakpoints: {
				640: { slidesPerView: 2.25, spaceBetween: 24 },
				740: { slidesPerView: 2.5, spaceBetween: 24 },
				840: { slidesPerView: 3, spaceBetween: 24 },
				1024: { slidesPerView: 3.5, spaceBetween: 28 },
				1320: { slidesPerView: 4, spaceBetween: 28 },
			},
		});
	});

	document.querySelectorAll('.awards-block').forEach((wrap) => {
		const swiperEl = wrap.querySelector('.awards-block__swiper');
		if (!swiperEl) return;

		const prevEl = wrap.querySelector('.awards-block__swiper-prev');
		const nextEl = wrap.querySelector('.awards-block__swiper-next');

		new Swiper(swiperEl, {
			slidesPerView: 1.1,
			spaceBetween: 16,
			speed: 600,
			loop: false,
			navigation: { prevEl, nextEl },
			breakpoints: {
				640: { slidesPerView: 1.5, spaceBetween: 24 },
				840: { slidesPerView: 4.5, spaceBetween: 24 },
				1024: { slidesPerView: 5, spaceBetween: 28 },
			},
		});
	});
});
